<template>
  <b-card
    no-body
    class="p-2"
  >
    <h3 class="mb-2">
      {{ $t('humanResources.civilStatus.edit.editCivilStatus') }}
    </h3>
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-row>
          <!-- name Scholarship field -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Customs"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.civilStatus.columns.civilStatusColumn')"
                :state="errors.length > 0 ? false:null"
              >
                <b-form-input
                  v-model="civilStatus.nombre"
                />
                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Description Field -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Description"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.civilStatus.columns.descriptionColumn')"
                :state="errors.length > 0 ? false:null"
              >
                <b-form-input
                  v-model="civilStatus.descripcion"
                />
                <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          type="submit"
        >
          {{ $t('Lists.saveChanges') }}
        </b-button>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  // BFormTextarea,

  BFormInvalidFeedback,
  BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import humanResources from '@/services/humanresources.service'
import { ref } from '@vue/composition-api'
import router from '@/router'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormInvalidFeedback,
    BFormGroup,
    BButton,
    ValidationProvider,
    ValidationObserver,

  },
  setup() {
    /* SERVICES */
    const {
      updateCivilStatus,
      fetchCivilStatusId,
    } = humanResources()

    // Data
    const civilStatus = ref({})
    fetchCivilStatusId(router.currentRoute.params, data => {
      civilStatus.value = data
    })
    /* Events */
    const onSubmit = () => {
      updateCivilStatus(civilStatus.value)
        .then(() => {
          router.push({ name: 'apps-human-resources-civil-status-list' })
        })
    }
    /* Validations */
    const fetchScholarshipData = ref(JSON.parse(JSON.stringify(civilStatus.value)))
    const resetclienteData = () => {
      fetchScholarshipData.value = JSON.parse(JSON.stringify(civilStatus))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetclienteData)
    return {
      // Data
      civilStatus,
      /* Events */
      onSubmit,
      // Validations
      required,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style>

</style>
